module.exports = __webpack_public_path__ + "static/footer-logo-627f1140e66e490f3e74112e59d74af6.png";